/**
 * Normalizes a user-entered event search query before sending it to the backend.
 *
 * Accepts plain numeric IDs and IDs prefixed with "E" or "e", with or without
 * a whitespace separator (for example: "E12345", "e 12345", "12345", "2025 E147").
 * - When an E-prefixed event ID is detected, it strips the prefix for the backend
 *   `search` parameter and also provides `idStartsWith`
 *   so that the frontend can refine the results to only include events whose ID begins
 *   with the given digits.
 * - For any other text/numeric input, it returns `{ search: '<trimmed_value>' }`.
 * - For invalid or empty inputs, it returns `null`.
 *
 * @param {string|unknown} value - Raw text entered by the user.
 * @returns {{ search: string, idStartsWith?: string } | null}
 */
const PREFIX = 'e';
const PREFIX_REGEX = new RegExp(`(?:^|\\b)${PREFIX}\\s*(\\d+)\\b`, 'i');

export function normalizeEventSearchInput(value) {
    if (typeof value !== 'string') {
        return null;
    }

    const trimmedValue = value.trim();

    if (!trimmedValue) {
        return null;
    }

    const prefixedMatch = trimmedValue.match(PREFIX_REGEX);
    if (prefixedMatch) {
        return {
            search: prefixedMatch[1],
            idStartsWith: prefixedMatch[1]
        };
    }

    return { search: trimmedValue };
}
